import { motion } from "framer-motion";
import { MapPin, BadgeCheck, Building, Landmark } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export const About = () => {
  const { t } = useLanguage();

  return (
    <section id="about" className="mx-auto max-w-7xl px-4 py-20 sm:px-6 sm:py-24">
      <div className="grid gap-12 lg:grid-cols-2">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <p className="text-xs font-bold uppercase tracking-widest text-rose-600">{t.brandFull}</p>
          <h2 className="mt-3 font-heading text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl">
            {t.about.heading}
          </h2>
          <p className="mt-2 text-base font-medium text-muted-foreground sm:text-lg">
            {t.about.subheading}
          </p>
          <p className="mt-6 text-sm leading-relaxed text-muted-foreground sm:text-base">
            {t.about.para1}
          </p>
          <p className="mt-4 text-sm leading-relaxed text-muted-foreground sm:text-base">
            {t.about.para2}
          </p>
          <div className="mt-8 space-y-3">
            {t.about.trust.map((item) => (
              <div key={item} className="flex items-center gap-2 text-sm font-medium">
                <BadgeCheck className="h-4 w-4 text-emerald-500" />
                {item}
              </div>
            ))}
          </div>
        </motion.div>

        <div className="space-y-6">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
            data-testid="about-head-office-card"
            className="rounded-2xl border border-border bg-card p-6 shadow-sm"
          >
            <div className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-rose-600 text-white">
                <Building className="h-5 w-5" />
              </span>
              <h3 className="font-heading text-lg font-semibold">{t.about.headOffice}</h3>
            </div>
            <p className="mt-4 flex items-start gap-2 text-sm leading-relaxed text-muted-foreground">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-rose-600" />
              {t.about.headAddress}
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
            data-testid="about-branch-office-card"
            className="rounded-2xl border border-border bg-card p-6 shadow-sm"
          >
            <div className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-amber-600 text-white">
                <Landmark className="h-5 w-5" />
              </span>
              <h3 className="font-heading text-lg font-semibold">{t.about.branchOffice}</h3>
            </div>
            <p className="mt-4 flex items-start gap-2 text-sm leading-relaxed text-muted-foreground">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-amber-600" />
              {t.about.branchAddress}
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
